<template>
	<Datepicker input-class="date_int" :typeable="true" :language="en" :value="dateValue" format="yyyy" :highlighted="highlighted" @input="updateValue" minimum-view="year"></Datepicker>
</template>

<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { en } from 'vuejs-datepicker/dist/locale';

export default {
	props: ['value'],
	name: 'customYearPicker',
	data: function() {
		return {
			en: en,
			highlighted: {
				dates: [new Date()],
			},
		};
	},
	components: {
		Datepicker,
	},
	computed: {
		dateValue() {
			return new Date().setUTCFullYear(this.value);
		},
	},
	methods: {
		updateValue: function(event) {
			this.$emit('input', this.valueFormat(event));
		},
		valueFormat(date) {
			if (date == null) return null;
			var inputDate = new Date(date);
			return moment(inputDate).format('yyyy');
		},
	},
};
</script>

<style>
.vdp-datepicker {
	display: inline-block;
}
</style>
